module.exports = __webpack_public_path__ + "static/impact-8e3d79527f23b26726552599ad76806e.woff";